import { SurveyQuestionTypes } from 'shared/surveys'
import { getSurveyTypeName } from '../../helpers'
import { SurveyResultsDownloadCsvQuery } from './SurveyResultsDownloadCSV.codegen'
import { t } from '@lingui/macro'

export const prepareSurveyResultsExportData = (
  data: Array<
    NonNullable<NonNullable<SurveyResultsDownloadCsvQuery['admin']>['survey']>
  >
) => {
  const survey = data[0]
  return survey.questions
    .filter((question) => question.type !== SurveyQuestionTypes.INFO)
    .flatMap((question) =>
      question.answers.map((answer) => {
        let answerValues
        if (question.type === SurveyQuestionTypes.TEXT) {
          answerValues = answer.value
        } else if (question.type === SurveyQuestionTypes.MULTIPLE_CHOICE) {
          answerValues = answer.value
            .map((id) => {
              return (question.content?.options ?? [])
                .filter((obj) => obj.id === id)
                .map((obj) => obj.label)
            })
            .join(', ')
        } else {
          answerValues = (question.content?.options ?? [])
            .filter((obj) => obj.id === answer.value)
            .map((obj) => obj.label)
        }
        const userWithAnswers = survey.usersWithAnswers.find(
          (userWithAnswers) => userWithAnswers.user.id === answer.user_id
        )
        const user = userWithAnswers?.user

        return {
          [t`Question`]: question.title,
          [t`Type`]: getSurveyTypeName(question.type),
          [t`Answer`]: answerValues,
          [t`Completed at`]: userWithAnswers?.completed_at,
          [t`User ID`]: user?.id,
          [t`Email`]: user?.email,
          [t`Display name`]: user?.display_name,
          [t`First name`]: user?.first_name,
          [t`Last name`]: user?.last_name,
          [t`Account name`]: user?.account_name,
          [t`Is active`]: user?.is_active,
          [t`Last active`]: user?.last_activity_at,
          [t`Creation method`]: user?.creation_method,
          [t`Created by`]: user?.createdBy?.display_name,
          [t`Created at`]: user?.created_at,
          [t`Mobile`]: user?.phone_number,
          [t`Role`]: user?.organisation_role,
          [t`Manager ID`]: user?.manager?.id,
          [t`Manager email`]: user?.manager?.email,
          [t`Manager name`]: user?.manager?.display_name,
          [t`Timezone`]: user?.timezone,
          [t`Locale`]: user?.locale,
          [t`Employee ID`]: user?.employee_id,
          [t`Position`]: user?.position,
          [t`Area`]: user?.area,
          [t`Location`]: user?.location,
          [t`Department`]: user?.department,
          [t`Custom 1`]: user?.custom_1,
          [t`Custom 2`]: user?.custom_2,
          [t`Custom 3`]: user?.custom_3,
          [t`Start at`]: user?.start_at,
          [t`Deleted at`]: user?.deleted_at
        }
      })
    )
}
